<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { ref } from 'vue'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Button,
  Input,
  Icon,
} from '@/components/ui'
import { createImageUpload } from '@/plugins'

const props = defineProps({
  ...nodeViewProps,
})

const link = ref<string>('')
const fileInput = ref()

function handleFile(event) {
  const files = event?.target?.files
  if (!props.editor || props.editor.isDestroyed || files.length === 0) return
  const file = files[0]
  const uploadOptions = props.editor.extensionManager.extensions.find(
    extension => extension.name === 'imageUpload'
  )?.options

  const uploadFn = createImageUpload({
    validateFn: () => {
      return true
    },
    onUpload: uploadOptions.upload,
  })
  uploadFn([file], props.editor.view, props.getPos())
}

function handleLink() {
  props.editor
    .chain()
    .setImage({ src: link.value })
    .deleteRange({ from: props.getPos(), to: props.getPos() })
    .focus()
    .run()
}
function handleDelete() {
  props.deleteNode()
}
function handleClick() {
  fileInput.value?.click()
}
</script>

<template>
  <NodeViewWrapper class="m-0 p-0" data-drag-handle>
    <Popover default-open>
      <PopoverTrigger as-child>
        <div
          class="hover:bg-accent border-border text-muted-foreground my-3 flex w-full cursor-pointer items-center rounded-sm border p-3 transition-all"
        >
          <div class="flex w-full items-center justify-between">
            <div class="flex items-center justify-center gap-3">
              <Icon name="ArrowUpOnSquareIcon" class="h-6 w-6" />
              <span class="text-sm">Add an image</span>
            </div>
            <Icon name="TrashIcon" class="hover:text-foreground" @click.stop="handleDelete" />
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent trap-focus class="w-full" :on-open-auto-focus="e => e.preventDefault()">
        <Tabs default-value="upload" class="w-[400px]" activation-mode="manual">
          <TabsList class="grid w-full grid-cols-2">
            <TabsTrigger value="upload">Upload</TabsTrigger>
            <TabsTrigger value="link">Url</TabsTrigger>
          </TabsList>
          <TabsContent value="upload">
            <Button class="mt-1 w-full" size="sm" @click="handleClick">Upload</Button>
            <input ref="fileInput" type="file" accept="image/*" multiple style="display: none" @change="handleFile" />
          </TabsContent>
          <TabsContent value="link">
            <form @submit.prevent="handleLink">
              <div class="flex items-center gap-2">
                <Input v-model="link" type="url" autofocus required placeholder="Link" />
                <Button type="submit">Apply</Button>
              </div>
            </form>
          </TabsContent>
        </Tabs>
      </PopoverContent>
    </Popover>
  </NodeViewWrapper>
</template>
